export enum NewUserQuestionnaireExperience {
    HaventUsedBefore = "HaventUsedBefore",
    Powerpoint = "Powerpoint",
    GoogleEarth = "GoogleEarth",
    GisAndCadSoftware = "GisAndCadSoftware",
    Iventis = "Iventis"
}